import axios from 'axios'

const apiClient = axios.create({
    baseURL: process.env.VUE_APP_CORPORATE_BASE_URL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
})

export default apiClient